'use strict';
import * as $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002foption$002foption$002ejs from "@awesome.me/webawesome/dist/components/option/option.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent from "./io.github.nguyenyou.webawesome.laminar.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_UOption$() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
  this.IF = null;
  this.IG = false;
  this.ID = null;
  this.IE = false;
  $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__(this, "wa-option");
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_UOption$ as $c_Lio_github_nguyenyou_webawesome_laminar_UOption$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_UOption$.prototype = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_UOption$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_UOption$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_UOption$ as $h_Lio_github_nguyenyou_webawesome_laminar_UOption$ };
$h_Lio_github_nguyenyou_webawesome_laminar_UOption$.prototype = $p;
$p.uH = (function() {
  if ((!this.IG)) {
    this.IF = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "value", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.IG = true;
  }
  return this.IF;
});
$p.VK = (function() {
  if ((!this.IE)) {
    this.ID = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "label", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.IE = true;
  }
  return this.ID;
});
$p.cQ = (function() {
  return $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002foption$002foption$002ejs;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_UOption$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_UOption$, "io.github.nguyenyou.webawesome.laminar.UOption$", ({
  jT: 1,
  bp: 1,
  bo: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_UOption$ as $d_Lio_github_nguyenyou_webawesome_laminar_UOption$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_UOption$;
function $m_Lio_github_nguyenyou_webawesome_laminar_UOption$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_UOption$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_UOption$ = new $c_Lio_github_nguyenyou_webawesome_laminar_UOption$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_UOption$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_UOption$ as $m_Lio_github_nguyenyou_webawesome_laminar_UOption$ };
